const T = "start", _ = "loading", S = "success", s = "fail", M = "disabled", c = {
  start: T,
  loading: _,
  success: S,
  fail: s,
  disabled: M
}, t = {
  black: "black",
  green: "green"
};
export {
  t as FORM_SUBMIT_COLOR,
  c as FORM_SUBMIT_STATE
};
